//@flow
import {combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form'
import {asyncErrorReducer, requestReducer} from '$src/requests/reducers'

import {type StoreState, type Action} from './types'

const initialAuth =
  localStorage.getItem('frank-auth') ||
  '{"tokensState": {"hasTokens": false}, "loginStatus": {"loggedIn": false}}'

const initialLocale = localStorage.getItem('frank-locale') || 'fi'

export const initialState: StoreState = {
  auth: JSON.parse(initialAuth),
  requests: {},
  client: {},
  asyncError: null,
  locale: initialLocale,
  form: {},
}

const mainReducer: Function = combineReducers({
  client: (clientState = initialState.client) => clientState,
  locale: (localeState = initialState.locale) => localeState,
  auth: (authState = initialState.auth) => authState,
  form: formReducer,
  requests: requestReducer,
  asyncError: asyncErrorReducer,
})

const rootReducer = (state: StoreState = initialState, action: Action<*>) => {
  switch (action.type) {
    case 'GENERIC/SET_STATE':
      return action.payload
    case 'LOGOUT':
      return initialState
    default:
      return mainReducer(state, action)
  }
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/index.js